import React from "react";
import DemoButton from "../Demo/DemoButton";
import CustomButton from "../Buttons/CustomButton";
import Link from "next/link";
import Image from "next/image";
import slider1 from "@/Helper/images/slider/manufacturing/slider1.png";

const Manufacturing = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">
          Streamline manufacturing processes with potential integration of AI
        </p>
        <p className="subheading">
          It uses deep learning & machine learning networks to optimize
          manufacturing operations with advanced data analysis &
          decision-making.
        </p>
        <div className="btn_container">
          <DemoButton PrimaryColorBtn />
          <Link href={"/manufacturing"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Digital signage software driving steadfast results"
            width={459}
            height={253}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default Manufacturing;
